module.exports = __webpack_public_path__ + "img/skid-steer-loader.3af04ab.png";